import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useCreatePriceLabel } from '@hero/hooks';
import { useGetPaymentMethods } from '@hero/services/organization-service/hooks';
import { cleanObjectEmptyFields } from '@hero/utils';

import { services } from '../../services';

export const useCreateAutomation = ({ options = {} } = {}) => {
  const { data: paymentMethodsData } = useGetPaymentMethods();
  const queryClient = useQueryClient();

  const { isCAActMustBeApplied } = useCreatePriceLabel({});

  const paymentMethods = paymentMethodsData?.paymentMethods || [];

  return useMutation(
    body =>
      services.create(
        cleanObjectEmptyFields({
          ...body,
          meta: {
            ...body?.meta,
            caActHasBeenApplied: !!isCAActMustBeApplied
          },
          paymentMethod: paymentMethods[paymentMethods.length - 1]
        })
      ),
    {
      ...options,
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['automations'], refetchType: 'active' });
      }
    }
  );
};
